module.exports = __webpack_public_path__ + "static/media/ClickerScript-Regular.b5cae760.ttf";